// src/components/GlobalError.jsx
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearError } from "../../redux/Actions/errorActions";
import MessageCard from "./../MessageCard/MessageCard";

export default function GlobalError() {
  const dispatch = useDispatch();
  const { open, message, type } = useSelector((s) => s.errors || {});
  useEffect(() => {
    if (open && message) {
      const timer = setTimeout(() => {
        dispatch(clearError());
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [open, message, dispatch]);

  if (!open || !message) return null;

  return (
    <MessageCard
      message={message}
      type={type}
      onClose={() => dispatch(clearError())}
    />
  );
}
